import React from "react";
import { Option } from "../Option";
import classNames from "classnames";
import styles from "./checkbox.module.scss";

export const Checkbox: React.FC<React.PropsWithChildren<Option & React.HTMLProps<HTMLDivElement>>> = (
  props
) => {
  return (
    <div
      onClick={(e) => {
        if (props.onSelect) {
          e.stopPropagation();
          props.onSelect(props.value);
        }
      }}
      data-testid={`checkbox-${props.testId}`}
      className={classNames(
        styles.Wrapper,
        {
          [styles.isChecked]: props.checked,
          [styles.disabled]: props.disabled,
        },
        props.className
      )}
    >
      {props.checked && (
        <img className={styles.Icon} src="/icons/ic_checked.svg" alt="check" />
      )}
    </div>
  );
};

export default Checkbox;
